import { getEndpoint } from '../../../features/common/backend/endpoints'
import axios from 'axios'

export async function updateFinancingData(
  credit_line_id,
  tna,
  montoFinanciar,
  quantity,
  avgQuoteValue,
  valorPrimeraCuota, 
  calculateAvgQuote,
  gastosFijos,
  quebrantoPorc
) {
  const response = await axios.post(
    getEndpoint('SIMULADOR_FINANCIERO') + '/GetCftQuoteAvg',
    {
      credit_line_id,
      tna,
      montoFinanciar,
      quantity,
      avgQuoteValue,
      valorPrimeraCuota,
      calculateAvgQuote,
      quebranto: Number(gastosFijos) || 0,
      quebrantoPorc: Number(quebrantoPorc) || 0,
      gastos: 0,
    }
  )
  return response?.data?.data
}
